import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=aa360cbe&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=aa360cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa360cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa360cbe')) {
      api.createRecord('aa360cbe', component.options)
    } else {
      api.reload('aa360cbe', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=aa360cbe&scoped=true&", function () {
      api.rerender('aa360cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HcsfLmTCT8Zd/JS/comp/SearchFilterTokens.vue"
export default component.exports